module.exports = __webpack_public_path__ + "static/media/contactMailDark.51cf7192.svg";